import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Router } from '@angular/router';

@Component({
  selector: 'app-success-popup',
  templateUrl: './success-popup.component.html',
  styleUrls: ['./success-popup.component.scss']
})
export class SuccessPopupComponent implements OnInit {
  showCloseBtn: boolean = true;
  constructor(public dialogRef: MatDialogRef<SuccessPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private $router: Router) { }

    ngOnInit() {
      this.showCloseBtn = this.data && this.data.showCloseBtn?true:false;
    }

  public submit(info:boolean): void {
    if(this.data && this.data.redirectUrl){
      setTimeout(()=>{
        this.$router.navigateByUrl(this.data.redirectUrl);
      },500)
    }
    this.dialogRef.close(info);

  }

}
